console.log("JavaScript ist geladen");
document.addEventListener("DOMContentLoaded", function() {
  const observer = new MutationObserver(function() {
    const genericSvg = document.querySelector('svg[aria-labelledby="pi-generic"]');
    if (genericSvg) {
      genericSvg.style.display = 'none';
      console.log("SVG wurde ausgeblendet");
      observer.disconnect(); // Stoppt das Beobachten, sobald das SVG gefunden wurde
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});